import React from 'react'
import Centered from 'shared/ui/Centered'
import Heading from 'shared/ui/Heading'
import { IconContent, IconContentText } from 'shared/ui/IconContent'
import { Hero } from '../ui/Hero'
import { SlantBackground } from '../ui/SlantBackground'
import Icon from 'shared/ui/Icon'

export default function BenefitsOfProfessionalTraining() {
  return (
    <div className="spacing-giant">
      <Hero>
        <div className="spacing">
          <Heading className="text-color-blue">Benefits of Training</Heading>
          <div className="text-large">How is Professional React Training beneficial?</div>
          <br />
        </div>
      </Hero>

      <SlantBackground shallowSlant verticalOffset={-6} />

      <Centered>
        <br />
        <div className="spacing-giant">
          <section>
            <ul className="list-reset spacing-large">
              <IconContent as="li" className="spacing-small">
                <IconContentText as={Heading} size={3}>
                  <Icon name="arrow-right" size={1.5} color="brightBlue" />
                  <strong>Invest in your team's knowledge</strong>
                </IconContentText>
                <p>
                  It might be one of the best investments you make. In-person React
                  training will cut many hours from a developers self-education
                  experience. Not only will they get up to date information, but they'll
                  be able to stay focused on guided topics instead of bouncing around
                  online tutorials.
                </p>
              </IconContent>
              <IconContent as="li" className="spacing-small">
                <IconContentText as={Heading} size={3}>
                  <Icon name="arrow-right" size={1.5} color="brightBlue" />
                  <strong>Shared Vocabulary</strong>
                </IconContentText>
                <p>
                  Your team will better communicate when they're on the same page with
                  best-practices and patterns. Programming in React is super fun, but it's
                  a new paradigms that might be unfamiliar to even seasoned developers. As
                  such, it comes with lots of terms. The workshops we put on have a big
                  emphasis on the correct React terminology.
                </p>
              </IconContent>
              <IconContent as="li" className="spacing-small">
                <IconContentText as={Heading} size={3}>
                  <Icon name="arrow-right" size={1.5} color="brightBlue" />
                  <strong>Architecture Focused</strong>
                </IconContentText>
                <p>
                  Anyone can read the docs and pick up the basic ideas of the syntax. Our
                  training takes it many steps beyond that. We want our attendees to feel
                  confident that they understand various React architectural ideas that
                  they can start to implement immediately when they're finished with
                  training.
                </p>
              </IconContent>
            </ul>
          </section>
        </div>
      </Centered>
    </div>
  )
}
